import ar from './ar.json';
import en from './en.json';

/**
 * The Questions module's catalogue, registered from `app.config.tsx` under the
 * `questions` namespace — `shared/i18n` never imports a module (W2).
 *
 * The visibility copy is the part that earns its length: each mode is stated as
 * its consequence ("Never shown") rather than as its enum (`forced_hidden`),
 * because that is the decision an operator is actually making.
 */
export const questionsCatalogs = { ar, en };
